var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 12.969a1.999 1.999 0 0 0-1.375.625l-9.875 10L7.312 25l1.375 1.406 9.876 10a2.011 2.011 0 0 0 2.875-2.812L14.905 27H40a1.988 1.988 0 0 0 1.754-.992 1.982 1.982 0 0 0 0-2.016A1.988 1.988 0 0 0 40 23H14.906l6.531-6.594a2.001 2.001 0 0 0-1.5-3.437Z"
  })));
};

export default SvgBack;